import {http} from "./api/restApiClient";

export const FacilitySettingsService = {
  updateSettings: (facilityId: string, settings: FacilitySettingsVariables) =>
    http.put<FacilitySettingsVariables>(
      `/facilities/${facilityId}/settings`,
      settings,
    ),
};

export type FileVariable = {
  type: "FILE";
  id: string;
  /**
   * Public link to the resource.
   */
  url: string;
};

export type FieldArrayItem = {
  /**
   * Unique id to find specific item in the array field.
   */
  id: string;
  [key: string]: number | string | ReadonlyArray<string>;
};

export type WorkflowSettingsVariables = {
  [key: string]: FacilitySettingsVariable;
};

/**
 * Possible facility settings values. Includes per-workflow settings (e.g. a
 * workflow-scoped checklist), keyed by workflow type under a "workflows" key
 * - kept separate from the top-level admission fields.
 */
export type FacilitySettingsVariable =
  | number
  | string
  | FileVariable
  | ReadonlyArray<string>
  | ReadonlyArray<FieldArrayItem>
  | {[workflowType: string]: WorkflowSettingsVariables};

export type FacilitySettingsVariables = {
  [key: string]: FacilitySettingsVariable;
};
